import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, Route, useParams } from "react-router-dom";
import { blogData } from "../blogs";
import TopicsContainer from "../components/blogs/TopicsContainer";
import OGtags from "../components/OGtags";
import { metaTags } from "../meta";
import { getTopic } from "../utils/config";

const Blog = (props) => {
  const { setFlag, flag, queryParams } = props;
  const { pillarTopic, subTopic } = useParams();

  return (
    <div className="container" style={{ marginTop: "200px" }}>
      <OGtags
        metaTitle={metaTags.blogs.metaTitle}
        metaDescription={metaTags.blogs.metaDescription}
        url={metaTags.blogs.url}
        ogTitle={metaTags.blogs.ogTitle}
        ogDescription={metaTags.blogs.ogDescription}
        ogImage={metaTags.blogs.ogImage}
      />

      <div className="row">
        <div className="col-12 mb-3">
          <p className="contactTitle">{pillarTopic ? getTopic(pillarTopic) : ""}</p>
        </div>
        {pillarTopic && !subTopic
          ? blogData
              .filter((v) => getTopic(v.pillarTopic) === pillarTopic)
              .map((blog, i) => {
                return i === 2 ? (
                  <>
                    <div className="col-12">
                      <TopicsContainer />
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                      <BlogTile blog={blog} />
                    </div>
                  </>
                ) : (
                  <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                    <BlogTile blog={blog} />
                  </div>
                );
              })
          : pillarTopic && subTopic
          ? blogData
              .filter(
                (v) => getTopic(v.pillarTopic) === pillarTopic && getTopic(v.subTopic) === subTopic
              )
              .map((blog, i) => {
                return i === 2 ? (
                  <>
                    <div className="col-12">
                      <TopicsContainer />
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                      <BlogTile blog={blog} />
                    </div>
                  </>
                ) : (
                  <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                    <BlogTile blog={blog} />
                  </div>
                );
              })
          : !pillarTopic && !subTopic
          ? blogData.map((blog, i) => {
              return i === 2 ? (
                <>
                  <div className="col-12">
                    <TopicsContainer />
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                    <BlogTile blog={blog} />
                  </div>
                </>
              ) : (
                <div className="col-md-6 col-sm-12 col-xs-12 col-lg-6">
                  <BlogTile blog={blog} />
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
};

export default Blog;

export const BlogTile = ({ blog, carausel }) => {
  const { imgSrc, date, title, url, pillarTopic, subTopic } = blog;
  return (
    <div className="p-3 my-3 border rounded blogTile">
      <Link style={{ textDecoration: "none", color: "#353535" }} to={url}>
        <div style={!carausel ? { height: "450px" } : { height: "450px", width: "250px" }}>
          <div style={{ height: "55%", width: "100%" }}>
            <img
              src={imgSrc}
              alt={title}
              style={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
                top: "0px",
                left: "0px",
              }}
            />
          </div>

          <p className="mt-3 mb-2 m-0 font-weight-bold">{date}</p>
          {pillarTopic ? (
            <Link style={{ color: "#353535" }} to={`/blogs/${getTopic(pillarTopic)}`}>
              <small className="mb-1 m-0 font-weight-bold">{pillarTopic}</small>
            </Link>
          ) : null}
          <div style={{ height: "20%", marginTop: "10px" }}>
            <h6 className="font-weight-bold" style={{ color: "rgba(229, 61, 84, 1)" }}>
              {title}
            </h6>
            {/* {pillarTopic && subTopic ? (
              <Link style={{ color: "#353535" }} to={`/blogs/${pillarTopic}/${subTopic}`}>
                <small className="mb-1 m-0 font-weight-bold">{subTopic}</small>
              </Link>
            ) : null} */}
          </div>

          <Link style={{ fontWeight: "bold", color: "#353535" }} to={url}>
            Read more
          </Link>
        </div>
      </Link>
    </div>
  );
};
